/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Object containing the fields to update with their new values
 * @export
 * @interface PatchJWTKeyRequestJwtKey
 */
export interface PatchJWTKeyRequestJwtKey {
    [key: string]: any | any;
    /**
     * New active status for the JWT key
     * @type {boolean}
     * @memberof PatchJWTKeyRequestJwtKey
     */
    active?: boolean;
    /**
     * New label for the JWT key
     * @type {string}
     * @memberof PatchJWTKeyRequestJwtKey
     */
    label?: string;
}

/**
 * Check if a given object implements the PatchJWTKeyRequestJwtKey interface.
 */
export function instanceOfPatchJWTKeyRequestJwtKey(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PatchJWTKeyRequestJwtKeyFromJSON(json: any): PatchJWTKeyRequestJwtKey {
    return PatchJWTKeyRequestJwtKeyFromJSONTyped(json, false);
}

export function PatchJWTKeyRequestJwtKeyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchJWTKeyRequestJwtKey {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
            ...json,
        'active': !exists(json, 'active') ? undefined : json['active'],
        'label': !exists(json, 'label') ? undefined : json['label'],
    };
}

export function PatchJWTKeyRequestJwtKeyToJSON(value?: PatchJWTKeyRequestJwtKey | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
            ...value,
        'active': value.active,
        'label': value.label,
    };
}

